// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.el-menu-item {\n  padding-left: 19px !important;\n}\n.el-menu-item.is-active {\n  background-color: #E6F7FF !important;\n  /* 替换为你想要的背景颜色，例如 #e5f6ff */\n  border-right: 2px solid #2593fc;\n}", ""]);
// Exports
module.exports = exports;
